import LayoutPrivate from './LayoutPrivate';

export default LayoutPrivate;
